<template>
    <div class="menu">
        <ul class="navigation">
            <li class="dashboard">
                <router-link to="/">
                    <span v-if="$mq=='sm'">{{'layouts/navigation.my-dashboard' | trans}}</span>
                    <span v-else>{{'layouts/navigation.summary' | trans}}</span>
                </router-link>
            </li>
            <li class="statements"><router-link to="/statements">{{'layouts/navigation.statements' | trans}}</router-link></li>
            <li class="payment" v-if="accBalance"><router-link to="/payment">{{'layouts/navigation.payment' | trans}}</router-link></li>
            <li class="settings" v-if="$mq=='lg'"><router-link to="/settings">{{'layouts/navigation.settings' | trans}}</router-link></li>
<!--            <li class="support" v-if="$mq=='lg'"><router-link to="/support">{{'layouts/navigation.support' | trans}}</router-link></li>-->
            <li class="logout" v-if="$mq=='lg'"><a  @click="logout"  href="">{{'layouts/navigation.logout' | trans}}</a></li>

        </ul>
    </div>
</template>

<script>
    import helper from '../services/helper';
    import {mapActions, mapState} from 'vuex';

    export default {

        data() {
            return {
               accBalance: 0
            }
        },

        methods: {
            ...mapActions(['clearStore']),

            logout(e){
                e.preventDefault();
                helper.logout().then(() => {
                    this.clearStore();
                    this.$router.replace('/login');
                })
            },
        },
        computed: {
            ...mapState(['user']),
        },
		watch: {
            'user.account_balance': {
                immediate: true,
                handler: function(old) {
                    this.accBalance = old;
                }
            }
		}
    }
</script>
